import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HelperService } from './helper.service';

const routes = {
  path: () => `/v1/elksearch-case/searchmultiselect`
};

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  constructor(private http: HttpClient, private helperService: HelperService) { }

  getColumnFilterItems(body: any, dashboardType: string, itemsType: string, globalSearchTerm: string): Observable<any[]> {
    body = this.helperService.replaceFilterBlanksSelectionMultipleSearch(body);
    let params = new HttpParams().set('searchCaseType', itemsType);
    params = dashboardType ? params.set('dashboardType', dashboardType) : params;
    params = globalSearchTerm ? params.set('querySearch', globalSearchTerm) : params;

    return this.http.post<any[]>(routes.path(), body, { params })
      .pipe(
        map((res: string[]) => {
          return res.map((item: any) => {
            item = item ? item : '[ Blanks ]';
            return {
              name: item,
              value: item
            }
          });
        }));
  }
}
